import { render, staticRenderFns } from "./ProtocolNumberRequest.vue?vue&type=template&id=8b7e46fa&"
import script from "./ProtocolNumberRequest.vue?vue&type=script&lang=js&"
export * from "./ProtocolNumberRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports